import { useState } from "react";

interface InlineTextInputProps {
  label: string;
  name: string;
  type?: string;
  value?: string;
  onChange?: (e: any) => void;
  hasBorder?: boolean;
  hasSubText?: string;
  errors?: Record<string, string>;
  disabled?: boolean;
  isReadOnly?: boolean;
  placeholder?: string;
  isFlexGrow?: boolean;
  classStyle?: string;
}

function InlineTextInput({
  label,
  name,
  type = "text",
  value = "",
  onChange,
  hasBorder = true,
  hasSubText = "",
  errors = {},
  placeholder = "",
  disabled = false,
  isReadOnly = false,
  isFlexGrow = false,
  classStyle = "",
}: InlineTextInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    // onChange?.(e);
  };

  return (
    <>
      <div
        className="mb-2 d-flex gap-2 align-items-center inline-text-container "
        style={{ height: "48px" }}
      >
        <div
          className={`${hasSubText?.length > 0 ? "d-flex flex-column gap-0" : ""}`}
        >
          <label
            className="col-form-label fw-semibol fs11 text-nowrap"
            htmlFor={name}
          >
            {label}
          </label>
          {hasSubText?.length > 0 && (
            <div
              className="col-form-label "
              style={{
                fontSize: "13px",
                marginTop: "-10px",
                fontWeight: "600",
              }}
            >
              {hasSubText}
            </div>
          )}
        </div>
        <div
          className={`ms-1 ${isFlexGrow ? "pe-2" : "col-7 col-sm-5 col-md-4"} d-flex flex-column `}
          style={{ minWidth: 170, maxWidth: 300, flexGrow: isFlexGrow ? 1 : 0 }}
        >
          <input
            id={name}
            type={type}
            name={name}
            placeholder={placeholder}
            className={`ps-1 flex-grow-1 form-control border-0 ${hasBorder ? "border-bottom " : ""} rounded-0 ${classStyle} `}
            // style={{ height: "30px" }}
            value={value}
            onChange={handleChange}
            disabled={disabled}
            readOnly={isReadOnly}
          />
          {errors[name]?.length > 0 && (
            <p className="flex-1 text-danger mt-1 ps-1 fs-12 ">
              {errors[name]}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default InlineTextInput;
